export type AuthPageMode = 'signIn' | 'signUp' | 'resetPassword';

/**
 * The form an auth route opens on: an explicit `mode` wins, otherwise the
 * route's own default (`/login` signs in, `/signup` signs up). An invite
 * token never picks the form, so invited people with an account can sign in.
 */
export function resolveAuthPageMode(args: {
  modeParam: string | null;
  defaultMode: 'signIn' | 'signUp';
}): AuthPageMode {
  if (args.modeParam === 'signup') return 'signUp';
  if (args.modeParam === 'reset') return 'resetPassword';
  if (args.modeParam === 'signin') return 'signIn';
  return args.defaultMode;
}
